import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { View } from 'react-native';
import { BiButton } from '../../../components/ui/BiButton';

/**
 * The confirm step, in place inside the panel: who will be able to use
 * the dataset, as the server counted them, before anything widens.
 */
export const DatasetAudienceConfirm = memo(
  ({
    lines,
    error,
    busy,
    onBack,
    onConfirm,
  }: {
    lines: Array<{ key: string; text: string }>;
    error: string | null;
    busy: boolean;
    onBack: () => void;
    onConfirm: () => void;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View style={{ gap: rpx(12) }}>
        <Typography.Text medium size={rpx(14)} color={aiColors.foreground}>
          确认后，这些人可以使用这份数据：
        </Typography.Text>
        <View
          style={{
            padding: rpx(12),
            gap: rpx(8),
            borderRadius: rpx(12),
            backgroundColor: aiColors.muted,
          }}
        >
          {lines.map(line => (
            <Typography.Text
              key={line.key}
              size={rpx(13)}
              color={aiColors.foreground}
            >
              {line.text}
            </Typography.Text>
          ))}
        </View>
        <Typography.Text
          size={rpx(12)}
          lineHeight={rpx(18)}
          color={aiColors.mutedForeground}
        >
          他们能预览这份数据的每一行，用它提问和做图表。数据里如果有客户电话、车牌等信息，请确认可以给他们看。
        </Typography.Text>
        {error ? (
          <Typography.Text size={rpx(12)} color={aiColors.destructive}>
            {error}
          </Typography.Text>
        ) : null}
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'flex-end',
            gap: rpx(8),
          }}
        >
          <BiButton title="返回修改" onPress={onBack} />
          <BiButton
            title="确认共享"
            tone="primary"
            loading={busy}
            onPress={onConfirm}
          />
        </View>
      </View>
    );
  },
);
